export default "__VITE_PUBLIC_ASSET__842f195f__"